import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navigation from './components/Navigation/Navigation';
import Footer from './components/Footer';
import SearchForm from './components/SearchForm';
import FeaturedListings from './components/FeaturedListings/FeaturedListings';
import ListingsPage from './components/ListingsView/ListingsPage';
import CreateListing from './components/ListingsView/createlisting/CreateListing';
import AddListingView from './components/ListingsView/createlisting/AddListingView';
import ListingDetails from './components/ListingsView/createlisting/ListingDetails';
import Register from './components/auth/Register';
import Contact from './components/Contact';
import Profile from './components/Profile';
import FavoritesPage from './components/FavoritesPage';
import AboutCompany from './components/Aboutcompany';
import FAQ from './components/FAQ';
import { FavoritesProvider } from './FavoritesContext';
import ScrollToTop from './ScrollToTop';

// Komponenty admina
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './components/admin/dashboard/AdminDashboard';
import AdminUsers from './components/admin/users/AdminUsers';
import AdminListings from './components/admin/listings/AdminListings';
import AdminComments from './components/comments/admin/AdminComments';
import AdminDiscounts from './components/discounts/admin/AdminDiscounts';

// Komponenty profilu użytkownika
import UserDashboard from './components/profil/UserDashboard';
import Messages from './components/profil/Messages';
import Notifications from './components/profil/Notifications';
import Transactions from './components/profil/Transactions';
import Stats from './components/profil/Stats';
import UserListings from './components/profil/UserListings';
import UserFavorites from './components/profil/Favorites';
import Settings from './components/profil/Settings';
import { useAuth } from './contexts/AuthContext';

// Komponent dla tras chronionych
const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
};

// Zawartość strony głównej
const HomePageContent = () => (
  <>
    <SearchForm />
    <FeaturedListings />
  </>
);

const App = () => {
  return (
    <AuthProvider>
      <FavoritesProvider>
        <Router>
          <ScrollToTop />
          <div className="flex flex-col min-h-screen">
            <Navigation />
            <main className="flex-grow">
              <Routes>
                {/* Strona główna */}
                <Route path="/" element={<HomePageContent />} />

                {/* Ogłoszenia */}
                <Route path="/listings" element={<ListingsPage />} />
                <Route path="/listing/:id" element={<ListingDetails />} />
                <Route
                  path="/createlisting"
                  element={
                    <ProtectedRoute>
                      <CreateListing />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/addlistingview"
                  element={
                    <ProtectedRoute>
                      <AddListingView />
                    </ProtectedRoute>
                  }
                />

                {/* Konto użytkownika */}
                <Route path="/register" element={<Register />} />
                <Route path="/contact" element={<Contact />} />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/favorites"
                  element={
                    <ProtectedRoute>
                      <FavoritesPage />
                    </ProtectedRoute>
                  }
                />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/about-company" element={<AboutCompany />} />

                {/* Panel Admina */}
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute requireAdmin>
                      <AdminLayout />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<AdminDashboard />} />
                  <Route path="users" element={<AdminUsers />} />
                  <Route path="listings" element={<AdminListings />} />
                  <Route path="comments" element={<AdminComments />} />
                  <Route path="discounts" element={<AdminDiscounts />} />
                </Route>

                {/* Panel użytkownika */}
                <Route
                  path="/user"
                  element={
                    <ProtectedRoute>
                      <UserDashboard />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<UserDashboard />} />
                  <Route path="messages" element={<Messages />} />
                  <Route path="notifications" element={<Notifications />} />
                  <Route path="transactions" element={<Transactions />} />
                  <Route path="stats" element={<Stats />} />
                  <Route path="listings" element={<UserListings />} />
                  <Route path="favorites" element={<UserFavorites />} />
                  <Route path="settings" element={<Settings />} />
                </Route>
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </FavoritesProvider>
    </AuthProvider>
  );
};

export default App;